import { render, staticRenderFns } from "./addReportDialog.vue?vue&type=template&id=2c5079e5&scoped=true"
import script from "./addReportDialog.vue?vue&type=script&lang=js"
export * from "./addReportDialog.vue?vue&type=script&lang=js"
import style0 from "./addReportDialog.vue?vue&type=style&index=0&id=2c5079e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5079e5",
  null
  
)

export default component.exports